// extracted by mini-css-extract-plugin
export default {"container":"ImagesLicensingList_container__MA0CV"};